import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/general";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/tencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/elegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/IRAILS/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";


const TODIS_IRAIL_FORM = ({ errors, touched, status }) => {
    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="internatRouteId" TetCategory="tentTCategory"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="description" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmDescDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysImpPmDescDTO.remarks" label="Remarks" name="railwaysImpPmDescDTO.remarks" disabled={status}/>
                            {errors.railwaysImpPmDescDTO && errors.railwaysImpPmDescDTO.remarks && touched.railwaysImpPmDescDTO && touched.railwaysImpPmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysImpPmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmStatusDTO" />
            </Tab>
            <Tab eventKey="elegibilityproject" title="TEN-T Project ">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmEligiTentDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysImpPmEligiTentDTO.remarks" label="Remarks" name="railwaysImpPmEligiTentDTO.remarks" disabled={status}/>
                            {errors.railwaysImpPmEligiTentDTO && errors.railwaysImpPmEligiTentDTO.remarks && touched.railwaysImpPmEligiTentDTO && touched.railwaysImpPmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysImpPmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T Compliance">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmTentcompDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysImpPmTentcompDTO.remarks" label="Remarks" name="railwaysImpPmTentcompDTO.remarks" disabled={status}/>
                            {errors.railwaysImpPmTentcompDTO && errors.railwaysImpPmTentcompDTO.remarks && touched.railwaysImpPmTentcompDTO && touched.railwaysImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Train traffic - forecasted" Label2="Train traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysImpPmPiDTO.remarks" label="Remarks" name="railwaysImpPmPiDTO.remarks" disabled={status}/>
                            {errors.railwaysImpPmPiDTO && errors.railwaysImpPmPiDTO.remarks && touched.railwaysImpPmPiDTO && touched.railwaysImpPmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysImpPmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="indicators" title="Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="railwaysImpPmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysImpPmIndicatorsDTO.remarks" label="Remarks" name="railwaysImpPmIndicatorsDTO.remarks" disabled={status}/>
                            {errors.railwaysImpPmIndicatorsDTO && errors.railwaysImpPmIndicatorsDTO.remarks && touched.railwaysImpPmIndicatorsDTO && touched.railwaysImpPmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysImpPmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default TODIS_IRAIL_FORM;